import { AfterViewInit, Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { IconService } from '@rp/shared/services';
import { MyBalanceComponent } from '@rp/pages/finance';
import { AuthBaseService, MyBalanceService, PageVisibilityComponent } from '@rp/core';

@Component({
  selector: 'rp-root',
  standalone: true,
  templateUrl: './app.component.html',
  imports: [RouterOutlet],
  providers: [IconService],
})
export class AppComponent extends PageVisibilityComponent implements OnInit, AfterViewInit {
  private _iconService = inject(IconService);
  private _myBalanceService = inject(MyBalanceService);

  constructor(authService: AuthBaseService) {
    super(authService);
  }

  ngOnInit(): void {
    this._iconService.registerIcons();
  }

  ngAfterViewInit(): void {
    this._myBalanceService.showMyBalanceComponent(MyBalanceComponent);
  }
}
